import React, { useEffect, useState } from 'react'; // Añade useState aquí
import { Link as Anchor } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faHome, 
    faUsers, 
    faCogs, 
    faShieldAlt, 
    faChartLine,
    faCheckCircle,
    faClock,
    faUserTie,
    faPlayCircle
} from '@fortawesome/free-solid-svg-icons';
import CountUp from 'react-countup';
import './PageNosotros.css';
import HeaderBack from '../../Components/HeaderBack/HeaderBack';

export default function PageNosotros() {
   const [imagesLoaded, setImagesLoaded] = useState(false);

   useEffect(() => {
        // Scroll suave al cargar en móvil
        if (window.innerWidth <= 768) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        
        // Marcar que las imágenes han comenzado a cargar
        setImagesLoaded(true);
    }, []);

    return (
        <div className="nosotros-page">
            {/* Encabezado con imagen de fondo */}
            <div className='bgPage' style={{ 
                backgroundImage: imagesLoaded ? 
                    `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(/images/dumpers.png)` : 
                    'none',
                backgroundColor: imagesLoaded ? 'transparent' : 'var(--color1)'
            }}>
                <HeaderBack title='Nosotros' />
                <div className="breadcrumb">
                    <Anchor to="/">
                        <FontAwesomeIcon icon={faHome} /> Inicio
                    </Anchor>
                    <span>|</span>
                    <Anchor to=''>
                        Nosotros
                    </Anchor>
                </div>
            </div>

            {/* Contenido Principal */}
            <div className="ProductsContainPage">
                <div className="nosotros-container">
                    {/* Sección Hero */}
                    <section className="hero-section">
                        <h1>Corporación Tech Mining One SAC</h1>
                        <p className="lead-text">Líderes en soluciones integrales para la industria minera</p>
                    </section>

                    {/* Sección Quiénes Somos */}
                    <section className="info-section">
                        <div className="section-header">
                            <FontAwesomeIcon icon={faUsers} className="section-icon" />
                            <h2>Quiénes Somos</h2>
                        </div>
                        <div className="section-content">
                            <p>Somos una empresa especializada en la venta de dumpers, repuestos y servicios de mantenimiento para la industria minera. Con sede en Perú, operamos a nivel nacional brindando soluciones técnicas de alta calidad.</p>
                            <p>Nuestra misión es proporcionar equipos y servicios que maximicen la productividad y seguridad en las operaciones mineras, con un enfoque en la innovación y la excelencia técnica.</p>
                            <div className="stats-grid">
                                <div className="stat-card">
                                    <FontAwesomeIcon icon={faChartLine} size="2x" style={{color: "var(--color1)", marginBottom: "1rem"}} />
                                    <h3><CountUp end={10} duration={2} />+</h3>
                                    <p>Años de experiencia</p>
                                </div>
                                <div className="stat-card">
                                    <FontAwesomeIcon icon={faUserTie} size="2x" style={{color: "var(--color1)", marginBottom: "1rem"}} />
                                    <h3><CountUp end={50} duration={2} />+</h3>
                                    <p>Clientes satisfechos</p>
                                </div>
                                <div className="stat-card">
                                    <FontAwesomeIcon icon={faCheckCircle} size="2x" style={{color: "var(--color1)", marginBottom: "1rem"}} />
                                    <h3><CountUp end={100} duration={2} />+</h3>
                                    <p>Equipos distribuidos</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Sección Nuestros Servicios */}
                    <section className="info-section">
                        <div className="section-header">
                            <FontAwesomeIcon icon={faCogs} className="section-icon" />
                            <h2>Nuestros Servicios</h2>
                        </div>
                        <div className="services-grid">
                            <div className="service-card">
                                <h3>Venta de Dumpers</h3>
                                <p>Distribuimos las mejores marcas de dumpers para minería con garantía extendida y soporte técnico especializado.</p>
                            </div>
                            <div className="service-card">
                                <h3>Repuestos Originales</h3>
                                <p>Amplio stock de repuestos originales para todas las marcas líderes, con trazabilidad garantizada.</p>
                            </div>
                            <div className="service-card">
                                <h3>Mantenimiento</h3>
                                <p>Servicios de mantenimiento preventivo y correctivo con técnicos certificados por los fabricantes.</p>
                            </div>
                            <div className="service-card">
                                <h3>Asesoría Técnica</h3>
                                <p>Soluciones personalizadas para optimizar el rendimiento y vida útil de sus equipos mineros.</p>
                            </div>
                        </div>
                    </section>

                    {/* Sección Nuestra Ventaja Competitiva */}
                    <section className="info-section">
                        <div className="section-header">
                            <FontAwesomeIcon icon={faShieldAlt} className="section-icon" />
                            <h2>Nuestra Ventaja</h2>
                        </div>
                        <div className="advantages-grid">
                            <div className="advantage-item">
                                <FontAwesomeIcon icon={faCheckCircle} style={{color: "var(--color1)", marginBottom: "1rem", fontSize: "1.5rem"}} />
                                <h3>Calidad Garantizada</h3>
                                <p>Todos nuestros productos cumplen con los más altos estándares internacionales de calidad y seguridad.</p>
                            </div>
                            <div className="advantage-item">
                                <FontAwesomeIcon icon={faClock} style={{color: "var(--color1)", marginBottom: "1rem", fontSize: "1.5rem"}} />
                                <h3>Respuesta Rápida</h3>
                                <p>Disponibilidad 24/7 para emergencias con tiempos de respuesta líderes en el sector.</p>
                            </div>
                            <div className="advantage-item">
                                <FontAwesomeIcon icon={faUserTie} style={{color: "var(--color1)", marginBottom: "1rem", fontSize: "1.5rem"}} />
                                <h3>Expertos Certificados</h3>
                                <p>Equipo técnico con certificaciones de fabricantes líderes y amplia experiencia en campo.</p>
                            </div>
                        </div>
                    </section>

                    {/* Nueva Sección: Video Corporativo */}
                    <section className="info-section">
                        <div className="section-header">
                            <FontAwesomeIcon icon={faPlayCircle} className="section-icon" />
                            <h2>Nuestro trabajo en acción</h2>
                        </div>
                        <div className="video-container">
                            <iframe 
                                src="https://www.youtube.com/embed/zpwGFZeeWxY" 
                                title="Video Corporativo Tech Mining One" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                allowFullScreen
                                className="responsive-iframe"
                            />
                            
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}